var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSearchLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20.5l-4.486-4.494M18 10a8.5 8.5 0 11-17 0 8.5 8.5 0 0117 0v0z",
    stroke: "#BEBEBE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

export default SvgIconSearchLarge;